module.exports = __webpack_public_path__ + "static/media/cateHogar.88f5c01c.jpg";